import React from 'react'

const Practice = () => {
    return (
        <div className="my-3">
            <h1>
                Practice
            </h1>
        </div>
    )
}

export default Practice
